<script lang="ts">
    import { appManager } from "../AppManager";
    import { ModalHook } from "../shared/modals/ModalHook";
    import { _ } from "svelte-i18n";
    import * as turf from "@turf/turf";
    import app from "../main";
    import { get } from "svelte/store";

    let hook: ModalHook<
        { lng: number; lat: number },
        "none" | "new" | "random-locations" | "trips-layers" | "demand-model"
    > = new ModalHook<
        { lng: number; lat: number },
        "new" | "random-locations" | "trips-layers" | "demand-model"
    >();
    appManager.ModalHooks.NewOdModal = hook;

    let open: boolean = false;
    let demandModelsEnabled: boolean = get(appManager.getCurrentUserAdminStore());
    appManager.getCurrentUserAdminStore().subscribe(value => {
        demandModelsEnabled = value;
    });

    // hook events.
    hook.on("open", () => {
        open = true;
    });
    hook.on("close", () => {
        open = false;
    });

    const close = () => {
        hook.close("none");
    };

    const chooseNew = () => {
        hook.close("new");
    };

    const chooseRandomLocations = () => {
        hook.close("random-locations");
    };

    const chooseTripsLayers = () => {
        hook.close("trips-layers");
    };

    const chooseDemandModel = () => {
        hook.close("demand-model");
    }

    let maxWidth = 900;
    let col = 4;
    $: if (demandModelsEnabled) {
        maxWidth = 1000;
        col = 3;
    }
</script>

{#if open}
    <div class="modal show" style="display: block;">
        <div class="modal-dialog modal-lg" style="max-width: {maxWidth}px;">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h4">
                        {$_("impact.scenario.matrixModal.addNew")}
                    </div>
                    <button
                        type="button"
                        class="btn-close btn-lg btn-close-lg"
                        aria-label="Close"
                        on:click={close} />
                </div>
                <div class="modal-body p-0">
                    <div class="container p-0">
                        <div class="row g-0">
                            <div
                            class="col-12 col-md-{col} p-2 aos-init aos-animate pointer"
                                data-aos="fade-up" on:click={() => chooseNew()} on:keypress={() => {}}>
                                <div
                                    class="card shadow-light-lg mb-6 mb-md-0 h-100">
                                    <img
                                        src="{appManager.PublicUrl}img/illustrations/matrix-types/matrix-manual.png"
                                        alt="..."
                                        class="card-img-top" />
                                    <div class="position-relative">
                                        <div
                                            class="shape shape-bottom shape-fluid-x svg-shim text-white">
                                            <svg
                                                viewBox="0 0 2880 48"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                ><path
                                                    d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                                                    fill="currentColor" /></svg>
                                        </div>
                                    </div>
                                    <div class="card-body position-relative">
                                        <h4>{$_("impact.scenario.matrixModal.empty")}</h4>
                                        <p class="text-muted ">
                                            {$_("impact.scenario.matrixModal.emptyExplanation")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-12 col-md-{col} p-2 aos-init aos-animate pointer"
                                data-aos="fade-up"
                                data-aos-delay="100"
                                on:click={() => chooseRandomLocations()}
                                on:keypress={() => {}}>
                                <div
                                    class="card shadow-light-lg mb-6 mb-md-0 h-100">
                                    <img
                                        src="{appManager.PublicUrl}img/illustrations/matrix-types/matrix-random.png"
                                        alt="..."
                                        class="card-img-top" />
                                    <div class="position-relative">
                                        <div
                                            class="shape shape-bottom shape-fluid-x svg-shim text-white">
                                            <svg
                                                viewBox="0 0 2880 48"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                ><path
                                                    d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                                                    fill="currentColor" /></svg>
                                        </div>
                                    </div>
                                    <div class="card-body position-relative">
                                        <h3>
                                            {$_(
                                                "impact.scenario.matrixModal.random"
                                            )}
                                        </h3>
                                        <p class="text-muted">
                                            {$_(
                                                "impact.scenario.matrixModal.randomExplanation"
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {#if demandModelsEnabled}
                            <div
                                class="col-12 col-md-{col} p-2 aos-init aos-animate pointer"
                                data-aos="fade-up"
                                data-aos-delay="100"
                                on:click={() => chooseDemandModel()}
                                on:keypress={() => {}}>
                                <div
                                    class="card shadow-light-lg mb-6 mb-md-0 h-100">
                                    <img
                                        src="{appManager.PublicUrl}img/illustrations/matrix-types/matrix-demand-model.png"
                                        alt="..."
                                        class="card-img-top" />
                                    <div class="position-relative">
                                        <div
                                            class="shape shape-bottom shape-fluid-x svg-shim text-white">
                                            <svg
                                                viewBox="0 0 2880 48"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                ><path
                                                    d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                                                    fill="currentColor" /></svg>
                                        </div>
                                    </div>
                                    <div class="card-body position-relative">
                                        <h3>
                                            {$_(
                                                "impact.scenario.matrixModal.demandModel"
                                            )}
                                        </h3>
                                        <p class="text-muted">
                                            {$_(
                                                "impact.scenario.matrixModal.demandModelExplanation"
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/if}
                            <div
                                class="col-12 col-md-{col} p-2 aos-init aos-animate pointer"
                                data-aos="fade-up"
                                data-aos-delay="100"
                                on:click={() => chooseTripsLayers()}
                                on:keypress={() => {}}>
                                <div
                                    class="card shadow-light-lg mb-6 mb-md-0 h-100">
                                    <img
                                        src="{appManager.PublicUrl}img/illustrations/matrix-types/matrix-trips.png"
                                        alt="..."
                                        class="card-img-top" />
                                    <div class="position-relative">
                                        <div
                                            class="shape shape-bottom shape-fluid-x svg-shim text-white">
                                            <svg
                                                viewBox="0 0 2880 48"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                ><path
                                                    d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                                                    fill="currentColor" /></svg>
                                        </div>
                                    </div>
                                    <div class="card-body position-relative">
                                        <h3>
                                            {$_(
                                                "impact.scenario.matrixModal.trips"
                                            )}
                                        </h3>
                                        <p class="text-muted">
                                            {$_(
                                                "impact.scenario.matrixModal.tripsExplanation"
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .pointer {
        cursor: pointer;
    }

    .modal {
        display: block;
    }

    .modal-lg {
        max-width: 800px;
    }
</style>
